import getInitiativeTypeLabel from './getInitiativeTypeLabel';

export default (initiatives) => (
  initiatives.reduce((a, { initiative_type: type, ...initiative }) => {
    const label = getInitiativeTypeLabel(type);
    const index = a.findIndex(({ name }) => name === label);

    if (index === -1) {
      return [...a, { id: a.length, items: [initiative], name: label }];
    }

    a[index].items.push(initiative);

    return a;
  }, [])
);
